export const AUTH_TOKEN = 'auth_token';
// export const LOCALHOST = 'http://localhost:9091/'
// export const LOCALHOST = 'https://community-portal.dev.inteligenta.io/'
export const LOCALHOST = 'https://portal.aspi.mk/'
export const PORTAL = 'https://portal.aspi.mk/'